import React, { memo } from "react";

import {
  Center,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalOverlay,
  Spinner,
} from "@chakra-ui/react";
import { useOverlay } from "modules/providers/overlay-provider";

const LoadingModal = () => {
  const { closeModal } = useOverlay();
  return (
    <Modal isOpen onClose={closeModal} isCentered>
      <ModalOverlay />
      <ModalContent>
        <ModalBody>
          <ModalCloseButton />
          <Center h="100%">
            <Spinner />
          </Center>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default memo(LoadingModal);
